import { Routes, Route } from 'react-router-dom';
import LanguageDetector from './LanguageDetector';
import LanguageAwareApp from './LanguageAwareApp';

// ----------------------------------------------------------------------

/**
 * LanguageRouter Component
 *
 * Root-level router that handles language-prefixed URLs
 * Wraps the entire application to enable multilingual routing
 *
 * Route Structure:
 * - "/" -> LanguageDetector (detects language and redirects to /:lang/)
 * - "/:lang/*" -> LanguageAwareApp (validates language and renders App)
 *
 * URL Examples:
 * - "/" -> redirects to "/en/" or "/es/"
 * - "/en/blog" -> renders Blog in English
 * - "/es/dashboard" -> renders Dashboard in Spanish
 * - "/fr/blog" -> redirects to "/en/blog" (invalid language)
 *
 * @component
 * @returns {JSX.Element} Language-aware routing structure
 */
export default function LanguageRouter() {
  return (
    <Routes>
      {/* Root path - detect and redirect to appropriate language */}
      <Route path="/" element={<LanguageDetector />} />

      {/* All application routes under language prefix */}
      <Route path="/:lang/*" element={<LanguageAwareApp />} />
    </Routes>
  );
}
